import GeneralButtonComponent from "../../../components/button/GeneralButtonComponent"
import PropTypes from 'prop-types';
import ImageAsync from "../../../components/native/ImageAsync";

const FoodCardOrderItem = ({ name, action = () => { }, img, link = '' }) => {

  return (
    <div className="w-full rounded border flex justify-between items-center p-2 mb-4 mt-4">
      <div className="flex items-center">
        <ImageAsync className="rounded-md" src={"/assets/img/svg/" + img} alt={name} width={'94px'} height={'94px'} />
        <span className="flex flex-col ml-4 pr-1" >
          <span style={{ fontSize: '16px' }}>{name}</span>
          <small style={{ color: '#4B5563' }}>2 órdenes</small>
        </span>
      </div>

      <span className="flex flex-col">
        <GeneralButtonComponent classes='primary_btn hover:primary_btn text-white py-2 px-6 he-50' click={action}
          bgcolor='#67BAAF'>Detalle </GeneralButtonComponent>

        <small className="mt-4" style={{ color: '#FF4747' }}>Cancelar pedido</small>
      </span>
    </div>
  );
};

FoodCardOrderItem.propTypes = {
  name: PropTypes.string,
  action: PropTypes.func,
  img: PropTypes.string,
  link: PropTypes.string
};

export default FoodCardOrderItem;
